import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./styles/newdetail.scss";
import { backend } from '../../components/apipath';
import axios from "axios";

function Newdetail() {
    const { new_id } = useParams();
    const [detailData, setDetailData] = useState({});
    // console.log(detailData);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${backend}home/newdetail/${new_id}`);
                setDetailData(response.data);
                // console.log(response.data);
            } catch (error) {
                console.error('Error fetching new detail:', error);
            }
        };
        fetchData();
    }, [new_id]);
    function cleanHTML(html) {
        if (!html) return "";
        return html.replace(/<p>(?:\s|&nbsp;| |<br\s*\/?>)*<\/p>/gi, '');
    }
    
    return (
        <>
            <div className="container">
                <div className="tabcontent">
                {Object.values(detailData).map((item, index) => (
                    <div className="mt100" key={index}>
                        <div className="w-100">
                            <h5 className="title mb-5">{item.title}</h5>
                            <div className="m-auto mb-5 article-content" dangerouslySetInnerHTML={{ __html: item.intro }} />
                            <div className="m-auto mb-5 article-content" dangerouslySetInnerHTML={{ __html: item.content }} />
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </>
    );
}

export default Newdetail;